// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"e732fe97","228":"4353397e","739":"d4fa9636","820":"09937917"}[chunkId] + ".chunk.css";
};